/**
 * Enum representing the type of a location
 */
export enum LocationType {
  ParcelPoint = 'ParcelPoint',
  PostBox = 'PostBox',
  PostOffice = 'PostOffice',
  PackageLabelDecides = 'PackageLabelDecides',
  Other = 'Other',
}

export function isLocationType(value: unknown): value is LocationType {
  return typeof value === 'string' && Object.keys(LocationType).includes(value);
}
